import { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../../hooks/useLanguage';
import { useTheme } from '../../hooks/useTheme';
import { MagneticButton } from '../UI/MagneticButton';

export const TopBar = () => {
  const { lang, setLang, LANGUAGES } = useLanguage();
  const { isDark, toggle } = useTheme();
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <nav className="
      fixed top-0 left-0 right-0 z-50
      backdrop-blur-md
      bg-[var(--card)]/80
      border-b border-[var(--border)]
    ">
      <div className="flex items-center justify-between px-4 py-3 mx-auto max-w-7xl sm:px-6">

        {/* Logo */}
        <div className="flex items-center min-w-0 gap-3">
          <img
            src="/images/gaiamundi-logo.png"
            alt="Gaiamundi"
            className="object-contain w-10 h-10 sm:w-12 sm:h-12"
          />
          <span className="hidden text-lg font-bold tracking-tight sm:block lg:text-xl font-syne whitespace-nowrap">
            GAIAMUNDI
          </span>
        </div>

        {/* Right Side Controls */}
        <div className="flex items-center gap-2">

          {/* ===== Mobile Language Dropdown ===== */}
          <div className="relative sm:hidden" ref={dropdownRef}>
            <button
              onClick={() => setOpen(!open)}
              className="
                px-3 py-1
                text-sm font-medium
                rounded-md
                bg-[var(--card)]
                border border-[var(--border)]
              "
            >
              {lang.toUpperCase()}
            </button>

            {open && (
              <div className="absolute right-0 flex flex-col w-24 gap-1 p-2 mt-2 rounded-lg shadow-xl glass">
                {LANGUAGES.map((l) => (
                  <button
                    key={l}
                    onClick={() => {
                      setLang(l);
                      setOpen(false);
                    }}
                    className={`
                      text-sm px-2 py-1 rounded
                      ${
                        lang === l
                          ? 'bg-[var(--accent)] text-[var(--bg)]'
                          : 'hover:bg-[var(--border)]'
                      }
                    `}
                  >
                    {l.toUpperCase()}
                  </button>
                ))}
              </div>
            )}
          </div>

          {/* ===== Desktop Language Inline ===== */}
          <div className="items-center hidden gap-1 sm:flex">
            {LANGUAGES.map((l) => (
              <button
                key={l}
                onClick={() => setLang(l)}
                className={`
                  text-sm px-3 py-1 rounded-md font-medium transition-all
                  ${
                    lang === l
                      ? 'bg-[var(--accent)] text-[var(--bg)]'
                      : 'hover:bg-[var(--card)]'
                  }
                `}
              >
                {l.toUpperCase()}
              </button>
            ))}
            <span className="mx-2 opacity-30">|</span>
          </div>

          {/* Theme Toggle */}
          <MagneticButton
            onClick={toggle}
            className="px-3 py-1 text-base sm:text-lg"
            aria-pressed={!isDark}
          >
            {isDark ? '☾' : '☀︎'}
          </MagneticButton>

        </div>
      </div>
    </nav>
  );
};
